module.exports = __webpack_public_path__ + "img/infraicon4.c3eae574.svg";